import {CircularProgress, Stack} from '@mui/material';
import {Suspense} from 'react';
import {ProfileForm} from '../profile-form/profile-form';
import {ProfileContainer, ProfileRoot, ProfileTitle} from '../profile.styles';

export const Profile = () => {
  return (
    <ProfileRoot>
      <ProfileTitle>Личный кабинет</ProfileTitle>
      <ProfileContainer gap="18px">
        <Suspense
          fallback={
            <Stack alignItems="center">
              <CircularProgress size={30} />
            </Stack>
          }
        >
          <ProfileForm />
        </Suspense>
      </ProfileContainer>
    </ProfileRoot>
  );
};
